(function ($) {
    $(document).ready(function () {
        // $('.testimonial-container').height( );
        setInterval(function () {
            var $activeTestimonial = $(".testimonial.active:first"),
                $nextTestimonial = $activeTestimonial.next();

            if (!$nextTestimonial.length) {
                $nextTestimonial = $(".testimonial:first");
            }

            $activeTestimonial.addClass('out');

            setTimeout(function () {
                $activeTestimonial.removeClass('active');
                $nextTestimonial.addClass('in');
                setTimeout(function () {
                    $activeTestimonial.removeClass('out');
                    $nextTestimonial.removeClass('in').addClass('active');
                }, 400);
                // $nextTestimonial
            }, 200);
        }, 5000);
    });
})(jQuery);
